import React from 'react';
import { Icon } from '@scale/scaleui';

const JobHighlightCards: React.FC = () => {
  return (
    <div className="flex flex-col w-fit outlier-theme scale-theme lg:pl-16 max-lg:w-full">
      <div className="text-base font-bold flex items-center">
        <Icon icon="sparkles" variant="black" />
        Opportunity Highlights
      </div>
      <div className="bg-utility-offWhite w-80 p-3 my-2 rounded">
        <div className="text-sm font-medium">Remote work</div>
        <div className="text-xs text-neutral-500 pt-2">
          Work from the comfort of your home, or wherever you want
        </div>
      </div>
      <div className="bg-utility-offWhite w-80 p-3 my-2 rounded">
        <div className="text-sm font-medium">Flexible hours</div>
        <div className="text-xs text-neutral-500 pt-2">Work anytime, you set your schedule</div>
      </div>
      <div className="bg-utility-offWhite w-80 p-3 my-2 rounded">
        <div className="text-sm font-medium">Weekly payouts</div>
        <div className="text-xs text-neutral-500 pt-2">Don't wait weeks to get paid</div>
      </div>
      <div className="bg-utility-offWhite w-80 p-3 my-2 rounded">
        <div className="text-sm font-medium">Flex your expertise</div>
        <div className="text-xs text-neutral-500 pt-2">
          Apply your skills to the development of the world's most exciting industry
        </div>
      </div>
    </div>
  );
};

export default JobHighlightCards;
